import { render, staticRenderFns } from "./companySubmenu.vue?vue&type=template&id=46790ac0&"
import script from "./companySubmenu.vue?vue&type=script&lang=ts&"
export * from "./companySubmenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports